import { css } from '@emotion/react'
import { memo } from 'react'
import { useRoomSelector } from '../../../Hooks/useRoomAppState'
import CardsIcon from '../../../Icons/Cards'
import TextIcon from '../../../Icons/Text'
import { getThemeSpacing } from '../../../styles/appTheme'
import { palette } from '../../../styles/colors'
import shape from '../../../styles/shape'

const previewsRootStyles = css({
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    zIndex: 24,
    right: getThemeSpacing(2),
    top: getThemeSpacing(6),
    padding: '7px 12px',
    borderRadius: shape.borderRadiusLarge,
    background: 'rgba(0,0,0,0.85)',
    color: palette.commonWhite,
    fontSize: '0.725rem',
    lineHeight: '1.25em',
    cursor: 'pointer',
    '& svg': {
        color: palette.commonWhite,
    },
})
const previewsHiddenStyles = css({
    '& svg': {
        marginLeft: getThemeSpacing(0.5),
        color: palette.commonWhite,
    },
})
const previewsShownStyles = css({
    top: getThemeSpacing(2),
})

interface PreviewCountProps {
    id: number
    onClick: () => void
    shown: boolean
}

const PreviewCount = memo((props: PreviewCountProps) => {
    const { id, onClick, shown } = props
    const previews = useRoomSelector(id, 'loungePreviews')

    const count = previews?.length

    return (
        <div
            onClick={onClick}
            data-testid="Chat__Previews"
            title={shown ? 'Lounge Chat' : 'Recently Shared Models'}
            css={[
                previewsRootStyles,
                // this is somewhat ugly as the icons are responsible for their own
                // positioning instead of the roomchat container
                shown ? previewsShownStyles : previewsHiddenStyles,
            ]}
        >
            {shown ? (
                <TextIcon size={'1.25em'} />
            ) : (
                <>
                    {count && <span>{String(count)}</span>}
                    <CardsIcon size={'1.25em'} />
                </>
            )}
        </div>
    )
})

export default PreviewCount
